import { extensions } from '@yola/ws-sdk';
import constants from '../constants';

const isBuilderEnabled = () => {
  const { enableBuilder } = extensions.accessors.getExtensionSettings(constants.common.slug);
  return enableBuilder;
};

export default isBuilderEnabled;
